import * as React from "react";
import PropTypes from "prop-types";
import { alpha } from "@mui/material/styles";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell, { tableCellClasses } from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableRow from "@mui/material/TableRow";
import Toolbar from "@mui/material/Toolbar";
import Typography from "@mui/material/Typography";
import Paper from "@mui/material/Paper";
import { IconButton, TableHead, TextField, Tooltip } from "@mui/material";
import { Search } from "@mui/icons-material";
import { styled } from "@mui/material/styles";
import { useNavigate } from "react-router";
import { fontSize, fontWeight, textTransform } from "@mui/system";
import moment from "moment";
import BorderColorRoundedIcon from "@mui/icons-material/BorderColorRounded";
import RemoveRedEyeRoundedIcon from "@mui/icons-material/RemoveRedEyeRounded";

const headCells = [
  {
    id: "id",
    numeric: false,
    disablePadding: true,
    label: "ID",
  },
  {
    id: "item",
    numeric: true,
    disablePadding: false,
    label: "ITEM",
  },
  {
    id: "cutomer-number",
    numeric: true,
    disablePadding: false,
    label: "CUSTOMER NAME",
  },
  {
    id: "payment-info",
    numeric: true,
    disablePadding: false,
    label: "PAYMENT INFO",
  },
  {
    id: "price",
    numeric: true,
    disablePadding: false,
    label: "PRICE",
  },
  {
    id: "status",
    numeric: true,
    disablePadding: false,
    label: "STATUS",
  },
  {
    id: "action",
    numeric: true,
    disablePadding: false,
    label: "ACTION",
  },
];

function EnhancedTableToolbar (props) {
  const { numSelected, handleChange } = props;

  return (
    <Toolbar
      sx={[
        {
          pl: { sm: 2 },
          pr: { xs: 1, sm: 1 },
        },
        numSelected > 0 && {
          bgcolor: theme =>
            alpha(theme.palette.primary.main, theme.palette.action.activatedOpacity),
        },
      ]}
    >
      {numSelected > 0 ? (
        <Typography sx={{ flex: "1 1 100%" }} color='inherit' variant='subtitle1' component='div'>
          {numSelected} selected
        </Typography>
      ) : (
        <Typography sx={{ flex: "1 1 100%" }} variant='h6' id='tableTitle' component='div'>
          Order List
        </Typography>
      )}
      {/* {numSelected > 0 ? (
        <Tooltip title='Delete'>
          <IconButton>
            <DeleteIcon />
          </IconButton>
        </Tooltip>
      ) : (
        <Tooltip title='Filter list'>
          <IconButton>
            <FilterListIcon />
          </IconButton>
        </Tooltip>
      )} */}
      <TextField
        placeholder='Search here...'
        InputProps={{
          endAdornment: (
            <IconButton color='inherit'>
              <Search />
            </IconButton>
          ),
        }}
        color='success'
        onChange={handleChange}
        style={{ backgroundColor: "", borderRadius: "4px" }}
      />
    </Toolbar>
  );
}

EnhancedTableToolbar.propTypes = {
  numSelected: PropTypes.number.isRequired,
};

const StyledTableRow = styled(TableRow)(({ theme }) => ({
  "&:nth-of-type(odd)": {
    backgroundColor: theme.palette.action.hover,
  },
  // hide last border
  "&:last-child td, &:last-child th": {
    border: 0,
  },
}));

const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: theme.palette.common.black,
    color: theme.palette.common.white,
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 14,
  },
}));

export default function OrderList ({ active, orders, handleClickOpenUpdate }) {
  const navigate = useNavigate();
  const showData = orders.filter(e =>
    active == 0
      ? e
      : active == 1
      ? e.deliveryStatus == "ordered"
      : active == 2
      ? e.deliveryStatus == "processing"
      : active == 3
      ? e.deliveryStatus == "canceled"
      : active == 4
      ? e.deliveryStatus == "shipping"
      : active == 5
      ? e.deliveryStatus == "delivered"
      : e.deliveryStatus == "picked-up"
  );

  const redirect = data => {
    navigate("/order-details", { state: { order: data } });
  };

  const deliveryLabels = {
    "pick-up": "Pick from Warehouse",
    abroad: "International Delivery",
    "nova-poshta": "Nova Poshta",
  };

  //   const [selected, setSelected] = React.useState([]);
  return (
    <>
      {/* <EnhancedTableToolbar handleChange={handleChange} numSelected={selected.length} /> */}
      <TableContainer component={Paper}>
        <Table sx={{ minWidth: 700 }} aria-label='customized table'>
          <TableBody>
            <TableRow>
              <StyledTableCell style={{ fontWeight: "500" }}>ID</StyledTableCell>
              <StyledTableCell style={{ fontWeight: "500" }} align='right'>
                DATE
              </StyledTableCell>
              <StyledTableCell style={{ fontWeight: "500", fontSize: "12px" }} align='right'>
                DELIVERY (METHOD/STATUS)
              </StyledTableCell>
              <StyledTableCell style={{ fontWeight: "500", fontSize: "12px" }} align='right'>
                PAYMENT (METHOD/STATUS)
              </StyledTableCell>
              <StyledTableCell style={{ fontWeight: "500" }} align='right'>
                PRICE
              </StyledTableCell>
              {/* <StyledTableCell style={{ fontWeight: "500" }} align='right'>
                STATUS
              </StyledTableCell> */}
              <StyledTableCell style={{ fontWeight: "500" }} align='right'>
                ACTION
              </StyledTableCell>
            </TableRow>
          </TableBody>
          <TableBody>
            {showData?.length == 0 && (
              <TableRow>
                <TableCell>No Order found</TableCell>
              </TableRow>
            )}
            {showData.map(row => (
              <StyledTableRow key={row.orderId}>
                <StyledTableCell component='th' scope='row'>
                  <span style={{ whiteSpace: "nowrap" }}>{row.invoiceId}</span>
                </StyledTableCell>
                <StyledTableCell align='right' style={{ textTransform: "capitalize" }}>
                  {moment(row.createdAt).format("ll")}
                </StyledTableCell>
                <StyledTableCell align='right' style={{ textTransform: "capitalize" }}>
                  <div>
                    {/* {row?.deliveryType == "nova-poshta" &&
                    moment(row?.createdAt).isAfter("2026-04-17")
                      ? row?.deliveryType == "nova-poshta"
                        ? "Abroad"
                        : row?.deliveryType == "abroad" &&
                          moment(row?.createdAt).isAfter("2026-04-17")
                        ? "Nova Poshta"
                        : row?.deliveryType
                      : row?.deliveryType} */}

                    {row?.deliveryType == "nova-poshta" &&
                    moment(row?.createdAt).isAfter("2026-04-17")
                      ? "International Delivery"
                      : row?.deliveryType == "nova-poshta" &&
                        moment(row?.createdAt).isBefore("2026-04-17")
                      ? deliveryLabels[row?.deliveryType]
                      : row?.deliveryType == "abroad" &&
                        moment(row?.createdAt).isAfter("2026-04-17")
                      ? "Nova Poshta"
                      : row?.deliveryType == "abroad" &&
                        moment(row?.createdAt).isBefore("2026-04-17")
                      ? deliveryLabels[row?.deliveryType]
                      : deliveryLabels[row?.deliveryType]}
                  </div>
                  <div
                    style={{
                      width: "fit-content",
                      borderRadius: "3px",
                      padding: "3px 5px",
                      fontSize: "12px",
                      marginLeft: "auto",
                      color:
                        row.deliveryStatus == "processing"
                          ? "#ffa500"
                          : row.deliveryStatus == "canceled"
                          ? "#B71D18"
                          : "#118D57",
                      fontWeight: "500",
                      textTransform: "capitalize",
                      backgroundColor:
                        row.deliveryStatus == "processing"
                          ? "rgba(255, 165, 0, 0.16)"
                          : row.deliveryStatus == "canceled"
                          ? "rgba(255, 86, 48, 0.16)"
                          : "rgba(34, 197, 94, 0.16)",
                    }}
                  >
                    {row.deliveryStatus}
                  </div>
                </StyledTableCell>

                <StyledTableCell align='right' style={{ textTransform: "capitalize" }}>
                  <div>{row.paymentType == "cod" ? "Cash on delivery" : row.paymentType}</div>
                  <div
                    style={{
                      width: "fit-content",
                      borderRadius: "3px",
                      padding: "3px 5px",
                      fontSize: "12px",
                      marginLeft: "auto",
                      color:
                        row.transactionStatus == "pending"
                          ? "#ffa500"
                          : row.transactionStatus == "declined"
                          ? "#B71D18"
                          : "#118D57",
                      fontWeight: "500",
                      textTransform: "capitalize",
                      backgroundColor:
                        row.transactionStatus == "pending"
                          ? "rgba(255, 165, 0, 0.16)"
                          : row.transactionStatus == "declined"
                          ? "rgba(255, 86, 48, 0.16)"
                          : "rgba(34, 197, 94, 0.16)",
                    }}
                  >
                    {row.transactionStatus}
                  </div>
                </StyledTableCell>
                <StyledTableCell align='right' style={{ fontWeight: "400" }}>
                  ₴{parseFloat(row.totalPrice) + parseFloat(row.deliveryPrice)}
                </StyledTableCell>
                {/* <StyledTableCell align='right'>
                  <span
                    style={{
                      borderRadius: "3px",
                      padding: "3px 5px",
                      fontSize: "12px",
                      color:
                        row.deliveryStatus == "processing"
                          ? "#ffa500"
                          : row.deliveryStatus == "canceled"
                          ? "#B71D18"
                          : "#118D57",
                      fontWeight: "500",
                      textTransform: "capitalize",
                      backgroundColor:
                        row.deliveryStatus == "processing"
                          ? "rgba(255, 165, 0, 0.16)"
                          : row.deliveryStatus == "canceled"
                          ? "rgba(255, 86, 48, 0.16)"
                          : "rgba(34, 197, 94, 0.16)",
                    }}
                  >
                    {row.deliveryStatus}
                  </span>
                </StyledTableCell> */}
                <StyledTableCell align='right'>
                  <span
                    style={{
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      gap: "8px",
                    }}
                  >
                    <Tooltip
                      title='Edit'
                      style={{ cursor: "pointer" }}
                      onClick={() => handleClickOpenUpdate(row)}
                    >
                      <BorderColorRoundedIcon />
                    </Tooltip>
                    <Tooltip
                      title='View'
                      style={{ cursor: "pointer" }}
                      onClick={() => redirect(row)}
                    >
                      <RemoveRedEyeRoundedIcon />
                    </Tooltip>
                  </span>
                  {/* <span
                    style={{
                      borderRadius: "3px",
                      padding: "3px 5px",
                      fontSize: "12px",
                      color: "white",
                      fontWeight: "500",
                      textTransform: "capitalize",
                      backgroundColor: "gray",
                      cursor: "pointer",
                    }}
                    onClick={() => handleClickOpenUpdate(row)}
                  >
                    Edit
                  </span> */}
                </StyledTableCell>
              </StyledTableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </>
  );
}
